import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ErrorBoundaryWithRouterClass extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });

    // Optional: log to console or analytics
    console.error('Error Boundary caught', {
      error,
      errorInfo,
      context: this.props.errorContext,
    });
  } // Native JS date formatting with IST
  getOSMessage = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isMobileUserAgent =
      /iphone|ipod|ipad|android|blackberry|windows phone|opera mini|mobile/i.test(
        userAgent
      );
    const isMac = /macintosh|mac os x/i.test(userAgent);
    const isSmallViewport = window.innerWidth <= 500; // Viewport width check

    const isMobile = isMobileUserAgent || isSmallViewport;

    if (isMobile) {
      return null;
    }

    const message = isMac ? 'with Cmd + Shift + R.' : 'with Ctrl + Shift + R.';
    return message;
  };
  render() {
    const formattedTimestamp = new Intl.DateTimeFormat('en-IN', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata', // Set to IST timezone
    }).format(new Date());

    if (this.state.hasError) {
      return (
        <div className="text-txtsecondary bg-txtsecondary-shades7 p-20px overflow-hidden w-full">
          <p className="text-title-l font-semibold text-txtlight ">
            Something went wrong!
          </p>
          <p className="text-title-m font-semibold text-txtsecondary">Try:</p>
          <ul className="text-txtlight text-body-l font-regular list-disc list-inside">
            <li>Refreshing the page {this.getOSMessage()}</li>
            <li>Clearing app cache</li>
          </ul>
          <p className="text-body-s font-regular ">
            Timestamp: {formattedTimestamp}
          </p>
          {process.env.REACT_APP_BUILD_ENV !== 'production' && (
            <div
              style={{ fontFamily: 'monospace' }}
              className="flex flex-col gap-4 mt-20px "
            >
              <>
                <h2 className="text-body-l font-semibold">Error Message:</h2>
                <pre className="text-body-s word-wrap whitespace-normal">
                  {this.state.error?.toString()}
                </pre>
              </>
              {/* <>
                <h2 className="text-body-l font-semibold">Context Info:</h2>
                <pre className="text-body-s">
                  {JSON.stringify(this.props.errorContext, null, 2)}
                </pre>
              </> */}
              <>
                <h2 className="text-body-l font-semibold">Extra Info:</h2>
                <pre className="text-body-s">
                  {JSON.stringify(
                    {
                      route: window.location.pathname,
                      query: window.location.search,
                    },
                    null,
                    2
                  )}
                </pre>
              </>
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
const ErrorBoundary = withRouter(ErrorBoundaryWithRouterClass);

export default ErrorBoundary;
